import styled from "styled-components";

export const OwnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  box-sizing: border-box;
  padding: 44px 30px;
`;

export const OwnerHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #121212;
  font-family: Pretendard;
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  > .button {
    cursor: pointer;
    border-radius: 13.898px;
    background: #7f25fb;
    width: 218px;
    height: 55px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    font-size: 18.531px;
    font-weight: 600;
    letter-spacing: -0.371px;
  }
`;

export const OwnerContentHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #121212;
  font-family: Pretendard;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 12px;
`;

export const OwnerContentHeaderRight = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  > input {
    border-radius: 15px;
    border: 1px solid #b7b7b7;
    display: flex;
    width: 230px;
    padding: 10px 15px;
    align-items: center;
    color: var(--Black-200, #b7b7b7);
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    outline: none;
  }
`;

export const OwnerContentWrapper = styled.div`
  border-radius: 14px;
  border: 0.707px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 22px 30px;
  box-sizing: border-box;
`;

export const OwnerContentTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const OwnerContentTableHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0 20px 4px;
  box-sizing: border-box;
  color: #121212;
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const OwnerContentTableItem = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  color: #121212;
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 10.638px;
  background: #ecf0f3;
  height: 50px;

  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .tournamentIds {
    flex: 1.5;
  }

  .button {
    border-radius: 6px;
    background: #bebebe;
    display: flex;
    width: 80px;
    height: 30px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    cursor: pointer;
  }

  img {
    cursor: pointer;
  }
`;

export const OwnerToggleItem = styled.div<{
  isOn: boolean;
}>`
  position: relative;
  cursor: pointer;
  width: 54px;
  height: 30px;
  background: ${(p) => (p.isOn ? "#7F25FB" : "#B7B7B7")};
  border-radius: 100px;
  transition: background 0.3s ease-in-out;
`;

export const OwnerToggleCircle = styled.div<{
  isOn: boolean;
}>`
  position: absolute;
  top: 4px;
  left: ${(p) => (p.isOn ? "28px" : "4px")};
  width: 22px;
  height: 22px;
  background: #fff;
  border-radius: 50%;
  transition: left 0.3s ease-in-out;
`;
